import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import BraouLayout from "@/components/layout/BraouLayout";
import BookingPage from "@/pages/booking-page/booking-page";
import ContactForm from "@/pages/contact-form/contact-form";
import ContactThanks from "@/pages/contact-thanks/contact-thanks";
import Food from "@/pages/food/food";
import Gallery from "@/pages/gallery/gallery";
import GuestInfo from "@/pages/guest-info/guest-info";
import Home from "@/pages/home/Home";
import Translate from "@/pages/translate/translate";

const changeSlugToTitleCase = (slug: string) => {
  const words = slug.split("-");
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const Pages: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    let title = location.pathname === "/" ? "" : location.pathname.slice(1);
    if (title === "guests") {
      const slug = location.hash.slice(1);
      if (slug) {
        title = `Guest Info | ${changeSlugToTitleCase(slug)}`;
      }
    }
    document.title = `Villa Braou | Sea View & Pool Holiday Rental in Crete | ${title.substring(0, 1).toUpperCase()}${title.substring(1)}`;
  });

  return (
    <Routes>
      <Route path="/" element={<BraouLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/food" element={<Food />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/guests" element={<GuestInfo />} />
        <Route path="/guests/:slug" element={<GuestInfo />} />
        <Route path="/thanks" element={<ContactThanks />} />
        <Route path="/admin/translate" element={<Translate />} />
      </Route>
    </Routes>
  );
};

export default Pages;
